/**
 * One presence status, rendered the only way this product renders one.
 *
 * A wrapper over `Badge` (Task 42), exactly the shape `attendance/StatusBadge.tsx`
 * already uses for its own nine-value vocabulary: it takes a `PresenceStatus` and
 * nothing else, so a caller cannot render a status with a colour and no words, the
 * wrong glyph, or a label it invented. `PRESENCE_STATUS_PRESENTATION` is the single
 * table and this is the single door to it.
 */

import type { ReactNode } from 'react';

import { useT } from '../../i18n';
import { PRESENCE_STATUS_PRESENTATION } from '../../presence/status';
import type { PresenceStatus } from '../../api/presence';
import { Badge } from '../../states/Badge';

export interface PresenceStatusBadgeProps {
  readonly status: PresenceStatus;
  readonly testId?: string;
}

export function PresenceStatusBadge({ status, testId }: PresenceStatusBadgeProps): ReactNode {
  const t = useT();
  const presentation = PRESENCE_STATUS_PRESENTATION[status];
  return (
    <Badge
      severity={presentation.severity}
      icon={presentation.icon}
      label={t(presentation.labelKey)}
      title={t(presentation.helpKey)}
      tone={presentation.tone}
      {...(testId === undefined ? {} : { testId })}
    />
  );
}
